import { SelectOption } from '@web-for-marketing/react-ui';

const australianStateOptions: SelectOption[] = [
    { value: 'ACT', content: 'Australian Capital Territory' },
    { value: 'NSW', content: 'New South Wales' },
    { value: 'NT', content: 'Northern Territory' },
    { value: 'Qld', content: 'Queensland' },
    { value: 'SA', content: 'South Australia' },
    { value: 'Tas', content: 'Tasmania' },
    { value: 'Vic', content: 'Victoria' },
    { value: 'WA', content: 'Western Australia' },
];

export default australianStateOptions;
